"use client";

import type { ChatsOrgNameConversationRouteParams } from "../route";
import {
  ConversationsProvider,
  ConversationsStore,
} from "../store/conversationsStore";
import { WebchatLayout } from "./components/WebchatLayout";
import { WebchatStore, WebchatProvider } from "./store";
import { useRouteParams } from "@/route";
import { useSubscribe } from "@deputy-ai/common/observable";
import { useCreation } from "ahooks";
import type { PropsWithChildren } from "react";

export function Layout({ children }: PropsWithChildren) {
  const convStore = useCreation(() => {
    return new ConversationsStore();
  }, []);
  const webchatStore = useCreation(() => new WebchatStore(), []);

  const {
    bind: { init },
  } = convStore;

  const { orgUid, name } =
    useRouteParams<ChatsOrgNameConversationRouteParams>();

  useSubscribe(() => init(orgUid, name), [convStore]);

  return (
    <div className="max-mobile:text-sm h-dvh overflow-hidden">
      <ConversationsProvider store={convStore}>
        <WebchatProvider store={webchatStore}>
          <WebchatLayout>{children}</WebchatLayout>
        </WebchatProvider>
      </ConversationsProvider>
    </div>
  );
}
